import Box from "@mui/material/Box";
import { hideLine } from "containers/events/tc-track/marker/line";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export default function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx={{
        boxSizing: "border-box",
        p: 3,
        // height: "100%",
        overflow:"hidden",
        flex: 1,
        // border: "1px dashed green"
      }}
    >
      {children}
    </Box>
  );
}
